import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { reactPlugin } from './services/appInsights';
import { AuthProvider } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
// import Analytics from './components/Analytics';
// import Cases from './components/Cases';
import CaseDetail from './components/CaseDetail';
import ExecutiveSummary from './components/ExecutiveSummary';
import ErrorNotifications from './components/ErrorNotifications';
import UnauthorizedPage from './components/UnauthorizedPage';
// DISABLED — W-2 tax filing demo (TEMPORARY)
// import TaxDemoRoutes from './features/tax-demo/routes';
import './App.css';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="flex h-screen bg-neutral-100">
      <Sidebar />
      {children}
      {/* Global Error Notifications */}
      <ErrorNotifications />
    </div>
  );
};

/**
 * Authenticated routes — wrapped in AuthProvider so the auth check
 * runs for every route change. The /unauthorized route is intentionally
 * OUTSIDE this component so it never triggers an auth check (the user
 * has no cookie on that page).
 */
const AuthenticatedApp: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />
        {/* Analytics route - commented out for now
        <Route
          path="/analytics"
          element={
            <Layout>
              <Analytics />
            </Layout>
          }
        />
        */}
        {/* Cases route - commented out for now
        <Route
          path="/cases"
          element={
            <Layout>
              <Cases />
            </Layout>
          }
        />
        */}
        <Route
          path="/executive-summary"
          element={
            <Layout>
              <ExecutiveSummary />
            </Layout>
          }
        />
        <Route
          path="/case/:caseNumber"
          element={
            <Layout>
              <CaseDetail />
            </Layout>
          }
        />
        {/* W-2 tax filing demo (TEMPORARY) — full-bleed layout, no Sidebar */}
        {/* DISABLED — W-2 tax filing demo (TEMPORARY) */}
        {/* <Route path="/tax-demo/*" element={<TaxDemoRoutes />} /> */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
};

const App: React.FC = () => {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <Router>
        <Routes>
          {/* Public route — no auth cookie required, no AuthProvider */}
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          {/* All other routes require authentication */}
          <Route path="/*" element={<AuthenticatedApp />} />
        </Routes>
      </Router>
    </AppInsightsContext.Provider>
  );
};

export default App;
